import React, { Component } from 'react';
import ScrollBar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CurrencyValue from './currencyValue';
import http from "../services/httpService";
import config from "../config.json";

class CryptoKur extends Component {
    state = {  
        values: [],
        header: this.props.header,
        style:{height: document.body.clientWidth > 990 ? this.props.height : null}
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async setValues(){
        var {data : values} =  await http.get(config.restEndpoint + 'Crypto');

        this.setState({values:values["data"]})
    }

    render() {
        return <div className="card crypto-head">
        <div className="card-body">
            <ScrollBar className="card-box cyripto" style={this.state.style} options={{ wheelSpeed: 0.2, swipeEasing :true }}>
              <div className="table-responsive">
                <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">{this.state.header} <span>(Bilgi amaçlıdır)</span></th>
                        <th scope="col"></th>
                        
                      </tr>
                    </thead>
                    <tbody>
                        {this.state.values.map(tag => <tr key={tag['symbol']}><td>{tag['symbol']}</td><CurrencyValue id={'buy' + tag['symbol']} value={tag['price']} currency={'$'}/></tr>)}
                    </tbody>
                  </table>
              </div></ScrollBar>
            </div>
        </div>;
    }

    
}
 
export default CryptoKur;